import { css } from "@emotion/core";
import { toPx } from "./styledSystem";

function getMediaMinWidth(props, breakpoint) {
  var breakpoints = props.theme.breakpoints;

  if (breakpoints[breakpoint]) {
    return toPx(breakpoints[breakpoint]);
  }

  return toPx(breakpoint);
}

function getMediaMaxWidth(props, breakpoint) {
  var breakpoints = props.theme.breakpoints;

  if (breakpoints[breakpoint]) {
    // The max width should be 1px less than the min width of the next
    // breakpoint, otherwise there will be an overlap in media queries.
    return toPx(parseFloat(breakpoints[breakpoint]) - 1);
  }

  return toPx(breakpoint);
}

export function lessThan(breakpoint, cssFn) {
  return function (props) {
    var maxWidth = getMediaMaxWidth(props, breakpoint);
    return (
      /*#__PURE__*/
      css("@media screen and (max-width:", maxWidth, "){", typeof cssFn === "function" ? cssFn(props) : cssFn, ";}")
    );
  };
}
export function greaterThan(breakpoint, cssFn) {
  return function (props) {
    var minWidth = getMediaMinWidth(props, breakpoint);
    return (
      /*#__PURE__*/
      css("@media screen and (min-width:", minWidth, "){", typeof cssFn === "function" ? cssFn(props) : cssFn, ";}")
    );
  };
}
export function between(fromBreakpoint, toBreakpoint, cssFn) {
  return function (props) {
    var minWidth = getMediaMinWidth(props, fromBreakpoint);
    var maxWidth = getMediaMaxWidth(props, toBreakpoint);
    return (
      /*#__PURE__*/
      css("@media screen and (min-width:", minWidth, ") and (max-width:", maxWidth, "){", typeof cssFn === "function" ? cssFn(props) : cssFn, ";}")
    );
  };
}